/** Firestore rejects property values of `undefined`. Walk plain objects/arrays and delete those keys. */
export function stripUndefinedFields(value: unknown): void {
  if (value === null || typeof value !== 'object') {
    return;
  }
  if (value instanceof Date) {
    return;
  }
  if (Array.isArray(value)) {
    value.forEach(item => stripUndefinedFields(item));
    return;
  }
  if (Object.getPrototypeOf(value) !== Object.prototype) {
    return;
  }
  const obj = value as Record<string, unknown>;
  for (const key of Object.keys(obj)) {
    if (obj[key] === undefined) {
      delete obj[key];
    } else {
      stripUndefinedFields(obj[key]);
    }
  }
}
